export default {
  type: 'content-api',
  routes: [
    {
      method: 'GET',
      path: '/user-activity/:groupId/:telegramId',
      handler: 'telegram-user-activity.getUserActivity'
    },
  ]
}
